(() => {
	angular.module('main').controller('ProductsController', ProductsController);

	ProductsController.$inject = [];

	function ProductsController() {}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/productsController.js